import DisplayMode from '../components/DisplayModeSwitch.vue'
import Pagination from '../shared/pagination.vue';
import FavoriteButton from '../shared/favorite-button.vue';

import confirmationmodal from '../shared/confirmation-modal.vue'
import NoResults from '../shared/no-results.vue'

import LoginModal from '../shared/login-modal.vue'

import savedsearchesmodal from '../vehicles/saved-searches-modal.vue';
import savesearchmodal from '../vehicles/save-search-modal.vue';
import loginmodal from '../shared/login-modal.vue';

import SearchService from '../scripts/services/pesquisa.js'
import Filters from '../scripts/filters.js'
import helper from '../scripts/helper.js'
import tagManager from '../scripts/tagManager';
import * as utils from "../scripts/utils.js";

Vue.filter("formatNumber", function (value) {
    if(value != null)
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return "";
});


const app = new Vue({
    el: "#search",
    data(){
        return {
            empty: false,
            showPageLoader: false,
            showFilterButtonLoader: false,
            filter: {
                BodyTypeId: [],
                BrandId: [],
                ModelId: [],
                Models: [],
                VersionId: [],
                ColorId: [],
                CountyId: [],
                DistrictId: [],
                FuelId: [],
                TransmissionId: [],
                FromProfessional: [],
                IsNational: [],
                Seats: [],
                GridView: true,
                OrderBy: "",
                IsEmpty: true,
                YearStart: "",
                YearEnd: ""
            },
            brands: {},
            models: [],
            bodyTypes: [],
            fuels: [],
            transmissions: [],
            colors: [],
            districts: [],
            sources: [],
            advertiserTypes: [],
            seats: [],
            filterTotal: 0,
            isCollapsed: true,
            savedSearchesCount: 0,
            urlLogin: "/account/signin?url=" + window.location.href,            
            pNum: 1,
            pSize: 48,
            result: {
                items: [],
                total: 0,
                filter: {}
            }
        };
    },
    props:{
        propOrderBy: {
            type: Number,
            default: 0
        },
        propIsGridView: {
            type:Boolean,
            default: true
        },
        propIsUsedVehicle: Boolean,
        isAuthenticated: {
            type: Boolean,
            default: false
        },
    },
    components: {
        DisplayMode,
        Pagination,
        NoResults,
        FavoriteButton,
        LoginModal,
        savedsearchesmodal,
        savesearchmodal,
        confirmationmodal,
        loginmodal
    },
    methods: {
        async onSearch(filter) {
            this.showPageLoader = true;

            if (filter == null)
                filter = this.filter;

            this.NormalizeFilter(filter);
        
            let filterQuery = await this.createFilterQuery(filter);

            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            if (filterQuery != null && filterQuery != ""){
                newurl += `?${filterQuery}`;
            }
            this.result.filter = { ...filter };

            await SearchService.SaveStatsSearchFilter(filterQuery);

            window.location = newurl;
            this.showPageLoader = false;
        },
        async createFilterQuery(filter){
            var params = new URLSearchParams(this.FilterQueries(filter));

            if (this.filter.OrderBy != 0){
                params.set("orderby", this.filter.OrderBy);
            }
            
            if (this.filter.GridView == false){
                params.set("gridview", "false");
            }
            
            if (this.pNum > 1){
                params.set("p", this.pNum);
            }
            
            params.sort();
            return decodeURI(params.toString());
        },
        async updateSearch() {
            this.pNum = 1;

            this.createEvent('pesquisa', 'pesquisar', true);

            this.onSearch();
        },
        async updateFilterAndSearch(){
            this.updateFilterTotal();
            this.updateSearch();
        },
        async updateFilterTotal() {
            this.showFilterButtonLoader = true;

            this.NormalizeFilter();
        
            let filterQuery = await this.createFilterQuery();
            
            await this.loadData(`?${filterQuery}`);

            this.showFilterButtonLoader = false;
        },
        async OnChangedViewMode(v) {
            this.propIsGridView = !this.propIsGridView;
            this.filter.GridView = this.propIsGridView;
            
            var newQuery = await this.createFilterQuery(this.result.filter);

            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?${newQuery}`;
            window.history.pushState({path:newurl},'',newurl);
        },
        getAdvertSubTitle (item){
            var advertSubTitle = `${item.Version} - ${item.HP.toString()}CV - ${item.Doors.toString()}P`;
            if (item.Version == null || item.Version == "")
            {
                advertSubTitle = `${item.HP.toString()}CV - ${item.Doors.toString()}P`;
            }
            return advertSubTitle;
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        getImageUrl(url, type) {
            var segments = url.split('/');

            var imgName = segments[segments.length - 1];
            var idAdvert = segments[segments.length - 2];
        
            if (!type) {
                return "/image/" + idAdvert + "/search/" + imgName;
            } else {
                return "/image/" + idAdvert + "/search/" + size + "/" + imgName;
            }
        },
        OnSearchChanged() {
            document.location = "/carros-usados";
        },
        OnChangedSearchViewMode(v){
            this.propIsGridView = v.IsGridView;
        },
        OnChangedSearchOrderBy(v){
            this.propOrderBy = v.OrderBy;
        },
        async OnPageChange(p) {
            this.pNum = p.PageNum;
            this.onSearch(this.result.filter);
        },
        async OnOrderByChange(){
            this.pNum = 1;
            this.onSearch(this.result.filter);
        },
        // Filter
        async loadSavedSearchesData() {
            if (!this.isAuthenticated) return;
            let d = await SearchService.GetSavedSearchesCount();
            this.savedSearchesCount = d;
        },
        async onClickSaveSearchesModal() {
            if (!this.isAuthenticated) {
                $("#saveSearchLoginModal").modal();
                return;
            }
            $("#saveSearch").modal();
        },
        async onClickOpenSavedSearchesModal() {
            if (!this.isAuthenticated) {
                $("#saveSearchLoginModal").modal();
                return;
            }
            await this.$refs.savedsearchmodal.loadData();
            $("#savedSearches").modal();
        },
        async onSearchSaved(r) {
            $("#saveSearch").modal('hide');

            this.createEvent('pesquisa', 'guardar', true);

            this.loadSavedSearchesData();
        },
        async OnSearchLoaded(filter) {
            this.filter = filter;
            this.onSearch();
        },
        async loadData(queryString) {

            if (queryString == null){
                queryString = window.location.search;
            }

            let d = await SearchService.GetSearchDataByFilter(queryString);
            
            this.brands = d.Brands;
            this.models = d.Models;
            this.bodyTypes = d.BodyTypes;
            this.fuels = d.Fuels;
            this.transmissions = d.Transmissions;
            this.colors = d.Colors;
            this.districts = d.Districts;
            this.sources = d.Sources;
            this.advertiserTypes = d.AdvertiserTypes;
            this.seats = d.Seats;

            this.filterTotal = d.Total;
        },
        async loadModels() {
            if (this.IsModelsActive()) {
                this.models = await SearchService.GetModels(this.filter.BrandId);
            }else{
                this.models = [];
            }
        },
        async onResetSearch() {

            this.createEvent('pesquisa', 'limpar', true);

            await SearchService.DeleteSearch();

            await this.OnSearchChanged();
        },
        async onBrandsChanged() {
            await this.loadModels();
            
            $('#ModelsDrop').selectpicker('refresh');
            $('#ModelsDrop').selectpicker('val', this.filter.ModelId);

            this.updateFilterTotal();
        },
        async onDeselectBrandsClick(e) {
            this.filter.BrandId = [];
            this.filter.ModelId = [];

            this.models = [];
            this.onBrandsChanged();
        },
        async onDeselectModelsClick(e) {
            this.filter.ModelId = [];

            this.updateFilterTotal();
        },
        NormalizeFilter(filter) {
            var f = filter;

            if (filter == null)
                f = this.filter;
            
            if (f.YearStart != null && f.YearStart == "") {
                f.YearStart = null;
            }

            if (f.YearEnd != null && f.YearEnd == "") {
                f.YearEnd = null;
            }

            if (f.PriceStart != null && f.PriceStart == "") {
                f.PriceStart = null;
            }

            if (f.PriceEnd != null && f.PriceEnd == "") {
                f.PriceEnd = null;
            }

            if (f.KmStart != null && f.KmStart == "") {
                f.KmStart = null;
            }

            if (f.KmEnd != null && f.KmEnd == "") {
                f.KmEnd = null;
            }

            this.filter.GridView = this.propIsGridView;
            this.filter.OrderBy = this.propOrderBy;
        },
        IsModelsActive() {
            // models dropdown is active according to the selected brands
            return (this.filter.BrandId != null && this.filter.BrandId.length > 0);
        },
        SetColapsedClass() {
            if (this.filter != null) {
                if (!helper.IsNullOrEmpty(this.filter.ColorId)
                    || !helper.IsNullOrEmpty(this.filter.IsNational)
                    || !helper.IsNullOrEmpty(this.filter.FromProfessional)
                    || !helper.IsNullOrEmpty(this.filter.Seats)) {
                    this.isCollapsed = false;
                    return;
                }
            }
            this.isCollapsed = true;
            return;
        },
        // gets the name of "ids" provided that are inside "elements"
        retrieveNamesByIds(elements, ids, separator = ", ") {
            if (!elements || !Array.isArray(elements) || !ids || !Array.isArray(ids)) {
                // Handle the case where elements or ids are not arrays or are undefined/null
                return [];
            }

            const names = [];

            for (const element of elements) {
                if (element && element.Id != null && ids.includes(element.Id)) {
                    names.push(element.Name);
                }
            }

            // instead of returning as array, returns a string where the items are separeted by coma ("1, 2, 3")
            return names.join(separator);
        },
        getSelectedMarcas(separator = ", ", filter) {
            if (filter == null)
                filter = this.filter;

            var popularSelected = this.retrieveNamesByIds(this.brands.Popular, filter.BrandId, separator)
            var otherSelected = this.retrieveNamesByIds(this.brands.Others, filter.BrandId, separator)
            
            if (otherSelected != null && otherSelected != ""){
                if (popularSelected != null && popularSelected.length == 0){
                    otherSelected = `${otherSelected}`;
                }else{
                    otherSelected = `${separator}${otherSelected}`;
                }
            }
            
            return popularSelected.concat(otherSelected);
        },
        getSelectedModels(separator = ", ", filter) {
            if (filter == null)
                filter = this.filter;

            let selected = "";

            if (!this.models || !this.models.Brands) {
                return selected; // If models or brands are missing, return the empty selected string
            }

            for (const brand of this.models.Brands) {
                // Iterate over each brand in the models.Brands array
                const brandModels = this.retrieveNamesByIds(brand.Models, filter.ModelId, separator);
                if (brandModels) {
                    if (selected) {
                        selected += separator;
                    }
                    selected += brandModels;
                }
            }

            return selected;
        },
        // Creates the object that will be sent to google tag manager data Layer
        createEvent(name, action, isUsed) {

            if (!this.filter)
                return;

            let analitycsProps = {
                'action': action,
                'isUsed': isUsed,
                'marca': this.getSelectedMarcas(),
                'modelo': this.getSelectedModels(),
                'ano_minimo': this.filter.YearStart,
                'ano_maximo': this.filter.YearEnd,
                'preco_minimo' : this.filter.PriceStart,
                'preco_maximo' : this.filter.PriceEnd,
                'kms_minimo': this.filter.KmStart,
                'kms_maximo' : this.filter.KmEnd,
                'cor': this.retrieveNamesByIds(this.colors, this.filter.ColorId),
                'combustivel': this.retrieveNamesByIds(this.fuels, this.filter.FuelId),
                'carrocaria': this.retrieveNamesByIds(this.bodyTypes, this.filter.BodyTypeId),
                'localizacao': this.retrieveNamesByIds(this.districts, this.filter.DistrictId),
                'caixa': this.retrieveNamesByIds(this.transmissions, this.filter.TransmissionId),
                'origem': this.retrieveNamesByIds(this.sources, this.filter.IsNational),
                'vendedor': this.retrieveNamesByIds(this.advertiserTypes, this.filter.FromProfessional),
                'lugares': this.retrieveNamesByIds(this.seats, this.filter.Seats),
                'pesquisa': this.filter.SearchTerm
            }

            tagManager.createEvent(name, analitycsProps)
        },
        FilterQueries(filter){
            var f = filter;
            if (filter == null){
                f = this.filter;
            }
            let separador = "|";
            var filterQueries = {};
            if (f){

                if (f.BrandId && f.BrandId.length > 0){
                    let brandsQuery = this.getSelectedMarcas(separador, f);
                    if (brandsQuery && brandsQuery.length > 0){
                        filterQueries.marca = helper.RemoveAccents(brandsQuery.toLowerCase());
                    }

                    if (f.ModelId && f.ModelId.length > 0){
                        let modelsQuery = this.getSelectedModels(separador, f);
                        if (modelsQuery && modelsQuery.length > 0){
                            filterQueries.modelo = helper.RemoveAccents(modelsQuery.toLowerCase()); 
                        }
                    }
                }
                
                if (f.FuelId && f.FuelId.length > 0){
                    let fuelsQuery = this.retrieveNamesByIds(this.fuels, f.FuelId, separador);
                    if (fuelsQuery && fuelsQuery.length > 0){
                        filterQueries.combustivel = helper.RemoveAccents(fuelsQuery.toLowerCase());
                    }
                }

                if (f.DistrictId && f.DistrictId.length > 0){
                    let districtQuery =  this.retrieveNamesByIds(this.districts, f.DistrictId, separador);
                    if (districtQuery && districtQuery.length > 0){
                        filterQueries.localizacao = helper.RemoveAccents(districtQuery.toLowerCase());
                    }
                }

                if (f.BodyTypeId && f.BodyTypeId.length > 0){
                    let bodyTypeQuery =  this.retrieveNamesByIds(this.bodyTypes, f.BodyTypeId, separador);
                    if (bodyTypeQuery && bodyTypeQuery.length > 0){
                        filterQueries.carrocaria = helper.RemoveAccents(bodyTypeQuery.toLowerCase());
                    }
                }

                if (f.ColorId && f.ColorId.length > 0){
                    let colorQuery =  this.retrieveNamesByIds(this.colors, f.ColorId, separador);
                    if (colorQuery && colorQuery.length > 0){
                        filterQueries.cor = helper.RemoveAccents(colorQuery.toLowerCase());
                    }
                }

                if (f.TransmissionId && f.TransmissionId.length > 0){
                    let transmissionQuery =  this.retrieveNamesByIds(this.transmissions, f.TransmissionId, separador);
                    if (transmissionQuery && transmissionQuery.length > 0){
                        filterQueries.caixa = helper.RemoveAccents(transmissionQuery.toLowerCase());
                    }
                }

                if (f.YearStart && f.YearStart > 0){
                    filterQueries["ano-min"] = f.YearStart;
                }
                
                if (f.YearEnd && f.YearEnd > 0){
                    filterQueries["ano-max"] = f.YearEnd;
                }

                if (f.PriceStart && f.PriceStart > 0){
                    filterQueries["preco-min"] = f.PriceStart;
                }

                if (f.PriceEnd && f.PriceEnd > 0){
                    filterQueries["preco-max"] = f.PriceEnd;
                }

                if (f.KmStart && f.KmStart > 0){
                    filterQueries["km-min"] = f.KmStart;
                }

                if (f.KmEnd && f.KmEnd > 0){
                    filterQueries["km-max"] = f.KmEnd;
                }

                if (f.IsNational && f.IsNational.length > 0){           
                    let isNationalQuery =  this.retrieveNamesByIds(this.sources, f.IsNational, separador);
                    if (isNationalQuery && isNationalQuery.length > 0){
                        filterQueries.origem = helper.RemoveAccents(isNationalQuery.toLowerCase());
                    }
                }
                
                if (f.FromProfessional && f.FromProfessional.length > 0){             
                    let fromProfessionalQuery =  this.retrieveNamesByIds(this.advertiserTypes, f.FromProfessional, separador);
                    if (fromProfessionalQuery && fromProfessionalQuery.length > 0){
                        filterQueries.vendedor = helper.RemoveAccents(fromProfessionalQuery.toLowerCase());
                    }
                }
                
                if (f.Seats && f.Seats.length > 0){             
                    // filterQueries.seats = helper.RemoveAccents(f.Seats);
                    let seatsQuery =  this.retrieveNamesByIds(this.seats, f.Seats, separador);
                    if (seatsQuery && seatsQuery.length > 0){
                        filterQueries.lugares = helper.RemoveAccents(seatsQuery.toLowerCase());
                    }
                }

                if (f.SearchTerm && f.SearchTerm.length > 0){
                    filterQueries.searchterm = helper.RemoveAccents(f.SearchTerm);
                }
            }
            return filterQueries;
        },
        normalizeUrlParams(params){
            if (params == null)
                params = new URLSearchParams(window.location.search);

            if (params.size > 0){

                if (params.get("orderBy") == 0){
                    params.delete("orderBy");
                }
                if (params.get("gridview") == 'true'){
                    params.delete("gridview");
                }
                if (params.get("p") == '1'){
                    params.delete("p");
                }
                
                params.sort();
                
                if (params.size > 0)
                    return window.location.pathname + `?${params.toString()}`;
            }
            return window.location.pathname;
        }
    },
    
    async beforeMount() {        
        this.filter = await SearchService.GetSearch();        

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("b") && urlParams.get("b") != null){
            this.filter = {
                BodyTypeId: [],
                BrandId: [],
                ModelId: [],
                VersionId: [],
                ColorId: [],
                CountyId: [],
                DistrictId: [],
                FuelId: [],
                TransmissionId: [],
                FromProfessional: [],
                Seats: [],
                IsNational: [],
                IsEmpty: true,
                YearStart: "",
                YearEnd: "",
                GridView: this.filter.GridView,
                OrderBy: this.filter.OrderBy
            };
            this.filter.BrandId = [parseInt(urlParams.get("b"))];
        }else{
            this.filter = {
                BodyTypeId: [],
                BrandId: [],
                ModelId: [],
                VersionId: [],
                ColorId: [],
                CountyId: [],
                DistrictId: [],
                FuelId: [],
                TransmissionId: [],
                FromProfessional: [],
                Seats: [],
                IsNational: [],
                IsEmpty: true,
                YearStart: "",
                YearEnd: "",
                GridView: this.filter.GridView,
                OrderBy: this.filter.OrderBy
            };
            if (globalFilter != null){
                this.filter = {
                    BodyTypeId: globalFilter.BodyTypeId,
                    BrandId: globalFilter.BrandId,
                    ModelId: globalFilter.ModelId,
                    VersionId: [],
                    ColorId: globalFilter.ColorId,
                    CountyId: [],
                    DistrictId: globalFilter.DistrictId,
                    FuelId: globalFilter.FuelId,
                    TransmissionId: globalFilter.TransmissionId,
                    FromProfessional: globalFilter.FromProfessional,
                    Seats: globalFilter.Seats,
                    IsNational: globalFilter.IsNational,
                    YearStart: globalFilter.YearStart,
                    YearEnd: globalFilter.YearEnd,
                    KmStart: globalFilter.KmStart,
                    KmEnd: globalFilter.KmEnd,
                    PriceStart: globalFilter.PriceStart,
                    PriceEnd: globalFilter.PriceEnd,
                    SearchTerm: globalFilter.SearchTerm,
                    IsEmpty: true,
                    GridView: globalFilter.GridView,
                    OrderBy: globalFilter.OrderBy
                };

                
            }
        }

        this.SetColapsedClass();

        this.propIsGridView = this.filter.GridView;
        this.propOrderBy = this.filter.OrderBy;

        this.OnChangedSearchViewMode({ IsGridView: this.filter.GridView });
        this.OnChangedSearchOrderBy({ OrderBy: this.filter.OrderBy });
        
        await this.loadData();
        await this.loadModels();

        this.result.filter = { ...this.filter };

        if(globalFilter != null && globalFilter.IsEmpty == false)
            this.createEvent('pesquisa', 'pesquisar', true);
    },
    mounted(){

        var params = new URLSearchParams(window.location.search);
        if (params.size > 0){
            window.history.replaceState({}, document.title, this.normalizeUrlParams(params));
        }

        this.propIsUsedVehicle = globalIsUsedVehicle;
        this.isAuthenticated = globalIsAuthenticated;
        
        this.$root.$on("OnPageChange", this.OnPageChange);
        
        $(document).ready(function () {

            $('.selectpicker').selectpicker({
                noneResultsText: 'Sem resultados'
            });

            $('.toggleFilter').on('click', function (e) {
                $('.filters').toggleClass("hide-all");
                $('body').toggleClass("no-scroll");
                e.preventDefault();
            });
            
            /////////
            
            $('.selectpicker').change(function() {
                $(this).next().next().children(".bs-searchbox").children("input[type='search']").blur();
            });
            
            
            /////////
        });

        this.loadSavedSearchesData();
    },
    async updated() {

        // refresh brands dropdown
        $('#BrandsDrop').selectpicker('refresh');
        $('#BrandsDrop').selectpicker('val', this.filter.BrandId);
        if (this.filter.BrandId.length > 0) $('#deselectBrands').show();

        // refresh models dropdown
        $('#ModelsDrop').selectpicker('refresh');
        $('#ModelsDrop').selectpicker('val', this.filter.ModelId);
        if (this.filter.ModelId.length > 0) $('#deselectModels').show();

        // refresh fuels dropdown
        $('#DropFuels').selectpicker('refresh');
        $('#DropFuels').selectpicker('val', this.filter.FuelId);

        // refresh BodyTypes dropdown
        $('#DropBodyTypes').selectpicker('refresh');
        $('#DropBodyTypes').selectpicker('val', this.filter.BodyTypeId);

        // refresh colors dropdown
        $('#DropColor').selectpicker('refresh');
        $('#DropColor').selectpicker('val', this.filter.ColorId);

        // refresh colors dropdown
        $('#DropTransmission').selectpicker('refresh');
        $('#DropTransmission').selectpicker('val', this.filter.TransmissionId);

        // refresh Districts dropdown
        $('#DropDistrict').selectpicker('refresh');
        $('#DropDistrict').selectpicker('val', this.filter.DistrictId);

        // refresh AdvrtiserTypes dropdown
        $('#DropSources').selectpicker('refresh');
        $('#DropSources').selectpicker('val', this.filter.IsNational);

        // refresh AdvrtiserTypes dropdown
        $('#DropAdvrtiserTypes').selectpicker('refresh');
        $('#DropAdvrtiserTypes').selectpicker('val', this.filter.FromProfessional);

        $('#DropSeats').selectpicker('refresh');
        $('#DropSeats').selectpicker('val', this.filter.Seats);

    },
    filters: {
        ToIconClass: Filters.ToIconClass
    },
    computed:{        
        
    }
});
